/** Not a Meta status — UI badge when stop_time/endTime has passed. */
export const SCHEDULE_FINISHED_DISPLAY = {
    label: "Finished",
    className: "bg-red-600 text-white",
};

const REVIEW_STATUSES = new Set([
    "IN_REVIEW",
    "PENDING_REVIEW",
    "DISAPPROVED",
    "PREAPPROVED",
    "WITH_ISSUES",
    "IN_PROCESS",
]);

export const isCampaignScheduleEnded = (endTime) => {
    if (!endTime) return false;
    return new Date(endTime) < new Date();
};

const shouldShowScheduleFinished = (effectiveStatus, endTime) => {
    if (!isCampaignScheduleEnded(endTime)) return false;
    if (effectiveStatus === "DELETED") return false;
    if (REVIEW_STATUSES.has(effectiveStatus)) return false;
    return true;
};

/**
 * statusMap = Meta effective_status values only.
 * Schedule-ended campaigns get SCHEDULE_FINISHED_DISPLAY (not from Meta).
 */
export const getCampaignStatusBadge = (effectiveStatus, endTime, statusMap) => {
    if (shouldShowScheduleFinished(effectiveStatus, endTime)) {
        return SCHEDULE_FINISHED_DISPLAY;
    }
    return (
        statusMap[effectiveStatus] || {
            label: effectiveStatus || "Unknown",
            className: "bg-slate-400 text-white",
        }
    );
};
